module.exports = __webpack_public_path__ + "img/gold_undraw_Choose_re_7d5a.10c1d23e.svg";